/* eslint-disable check-file/filename-naming-convention -- index.ts does not follow the usual naming convention */
import ExcelIcon from "@/ui/theme/icons/documents/ExcelIcon";
import GenericIcon from "@/ui/theme/icons/documents/GenericIcon";
import ImageIcon from "@/ui/theme/icons/documents/ImageIcon";
import InvalidDocumentIcon from "@/ui/theme/icons/documents/InvalidDocumentIcon";
import PDFIcon from "@/ui/theme/icons/documents/PDFIcon";
import WordIcon from "@/ui/theme/icons/documents/WordIcon";

export {
  ExcelIcon,
  GenericIcon,
  ImageIcon,
  InvalidDocumentIcon,
  PDFIcon,
  WordIcon,
};
